import * as Sentry from '@sentry/browser';

import { PRIVATE_API_BASE_URL } from '../constants';

const makeApiRequest = async (url, data, method = 'POST') => {
  const response = await fetch(`${PRIVATE_API_BASE_URL}${url}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();

  if (!response.ok) {
    console.error(responseData);
    // console.error(responseData.error);
    Sentry.addBreadcrumb({
      category: 'api',
      message: `Request sent to ${url}`,
      data: JSON.stringify({ paylod: data, responseData }, null, 2),
    });
    throw new Error(`Private API | ${url} | ${responseData}`);
  }

  return responseData;
};

export default makeApiRequest;
